import { useEffect, useState } from 'react';
import { useValidateActiveParticipantTinQuery } from '../graphql/generated';
import { tinValidationError } from '../utils/tin';
import { signatureDateValidationError } from '../utils/signatureDate';

export default function useActiveParticipantTINValidation({
  dcId,
  tin,
  signatureDate,
}: {
  dcId?: string | null;
  tin: string;
  signatureDate?: string | null;
}) {
  const [checkedTin, setCheckedTin] = useState(tin);
  useEffect(() => {
    const timeout = setTimeout(() => setCheckedTin(tin), 150);
    return () => clearTimeout(timeout);
  }, [tin]);
  const canCheck = Boolean(
    dcId &&
      !tinValidationError(tin) &&
      !signatureDateValidationError(signatureDate)
  );
  const { data, loading, error } = useValidateActiveParticipantTinQuery({
    variables: {
      dc_id: dcId || '',
      tin: checkedTin,
      signature_date: signatureDate || '',
    },
    skip: !canCheck || checkedTin !== tin,
    fetchPolicy: 'network-only',
  });
  const checking = canCheck && (checkedTin !== tin || loading);
  const warning =
    !canCheck || checking
      ? undefined
      : error
      ? 'Unable to check the participant TIN list. Please try again later.'
      : data && !data.analytics_analytics_cms_active_dce_participants.length
      ? 'This TIN is not in the active participant list on this signature date'
      : undefined;
  return { warning, checking };
}
